import { render } from "./TransferBalanceModal.vue?vue&type=template&id=129c8e39&scoped=true"
import script from "./TransferBalanceModal.vue?vue&type=script&lang=js"
export * from "./TransferBalanceModal.vue?vue&type=script&lang=js"

import "./TransferBalanceModal.vue?vue&type=style&index=0&id=129c8e39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129c8e39"]])

export default __exports__